




















































import Vue, { PropType } from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

const USER_IDENTIFIER_MAX_COUNT = 190;

export interface EditUserIdentifier {
  lang: any;
  supportUrl: string;
  userIdentifier: string;
  volumeLicenseId: string;
  userId: string;
}

export default Vue.extend({
  name: "vc-edit-user-identifier",
  props: {
    lang: {
      type: Object as PropType<EditUserIdentifier["lang"]>,
      default: () => {},
    },
    supportUrl: {
      type: String as PropType<EditUserIdentifier["supportUrl"]>,
      default: "",
    },
    userIdentifier: {
      type: String as PropType<EditUserIdentifier["userIdentifier"]>,
      default: "",
    },
    volumeLicenseId: {
      type: String as PropType<EditUserIdentifier["volumeLicenseId"]>,
      default: "",
    },
    userId: {
      type: String as PropType<EditUserIdentifier["userId"]>,
      default: "",
    },
  },
  data() {
    return {
      showModal: false,
      currentUserIdentifier: this.userIdentifier,
      draftUserIdentifier: "",
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("editUserIdentifier", ["getUserIdentifier"]),
  },
  methods: {
    ...mapActions("common", ["createNotification", "createErrorNotification"]),
    ...mapActions("editUserIdentifier", ["patchEditUserIdentifier"]),
    ...mapMutations("editUserIdentifier", [
      "updateVolumeLicenseId",
      "updateUserId",
    ]),
    async editUserIdentifier() {
      this.updateVolumeLicenseId(this.volumeLicenseId);
      this.updateUserId(this.userId);
      this.isLoading = true;
      try {
        await this.patchEditUserIdentifier({
          user_identifier: this.draftUserIdentifier,
        });
        this.currentUserIdentifier = this.getUserIdentifier;
        this.createNotification({
          label: this.lang.save_complete,
          style: "is-success",
        });
      } catch {
        this.createErrorNotification({
          label: this.lang.save_error_alert,
          style: "is-danger",
          linkLabel: this.lang.link_in_description,
          link: this.supportUrl,
        });
      }
      this.isLoading = false;
      this.closeModal();
    },
    doSend() {
      if (this.draftUserIdentifier.length === 0) {
        window.alert(this.lang.input_error.required);
      } else if (this.draftUserIdentifier.length > USER_IDENTIFIER_MAX_COUNT) {
        window.alert(
          this.lang.input_error.length.replace(
            ":length",
            USER_IDENTIFIER_MAX_COUNT
          )
        );
      } else if (this.draftUserIdentifier === this.currentUserIdentifier) {
        window.alert(this.lang.input_error.similar);
      } else {
        this.editUserIdentifier();
      }
    },
    openModal() {
      this.showModal = true;
      this.draftUserIdentifier = this.currentUserIdentifier;
    },
    closeModal() {
      this.showModal = false;
      this.draftUserIdentifier = this.currentUserIdentifier;
    },
  },
});
